import { Alert, Group, Stack, Text, Title } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import { ProductTypeBadge } from '../components/ProductTypeBadge';
import { MenuStatusBadge } from '../components/MenuStatusBadge';
import { MenuStatusHelpIcon } from '../components/MenuStatusHelpIcon';
import { MealPeriodBadges } from '../components/MealPeriodBadges';
import { LastUpdatedText } from '../components/LastUpdatedText';
import { RECENT_UPDATE_MESSAGE, RECENT_UPDATE_TITLE, UNTITLED_MENU_TEXT } from '../constants';
import { menuLevelPriceLabel } from '../helpers';
import type { MenuTemplateDetail } from '../types';

type MenuDetailsHeaderProps = {
  template: MenuTemplateDetail;
};

export const MenuDetailsHeader: React.FC<MenuDetailsHeaderProps> = ({ template }) => {
  const perPersonPrice = menuLevelPriceLabel(template);

  return (
    <Stack gap={8}>
      <Group gap={8} wrap="nowrap" align="center">
        <ProductTypeBadge productType={template.productType} />
        <Title order={4}>{template.name || UNTITLED_MENU_TEXT}</Title>
        {perPersonPrice ? (
          <Text fw={600} ml="auto" style={{ whiteSpace: 'nowrap' }}>
            {perPersonPrice}
          </Text>
        ) : null}
      </Group>
      <Group gap={8} align="center" wrap="wrap">
        <MealPeriodBadges mealPeriods={template.mealPeriods} />
        <MenuStatusBadge state={template.state} />
        <MenuStatusHelpIcon state={template.state} />
        <LastUpdatedText date={template.updatedAt} />
      </Group>

      {template.recentlyUpdated && (
        <Alert
          variant="light"
          color="blue"
          title={RECENT_UPDATE_TITLE}
          icon={<IconInfoCircle size={18} />}
          styles={{
            message: { color: 'var(--mantine-color-blue-light-color)' },
          }}
        >
          {RECENT_UPDATE_MESSAGE}
        </Alert>
      )}
    </Stack>
  );
};
